export default __webpack_public_path__ + "static/media/sanaType2.2ae15740.PNG";